import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=09000290&scoped=true&"
var script = {}
import style0 from "./Copyright.vue?vue&type=style&index=0&id=09000290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09000290",
  null
  
)

export default component.exports